module.exports = __webpack_public_path__ + "img/0-md.125679db.jpg";